import { useQuery } from "@apollo/client";
import { GET_COMPANY } from "../data";
import { isSmartTV } from "../helpers";

/**
 * Timezones problemáticos en Smart TVs y sus equivalentes seguros
 * Estos timezones tienen reglas DST desactualizadas en sistemas embebidos
 */
const PROBLEMATIC_TIMEZONE_REPLACEMENTS = {
  // Mexico_City cambió reglas DST en octubre 2022 (ahora UTC-6 todo el año)
  // Reemplazar por timezone equivalente más estable
  'America/Mexico_City': 'America/Monterrey', // Mismo offset UTC-6, reglas más estables
} as const;

/**
 * Corrige timezone problemático solo en Smart TVs
 */
const getCorrectTimezone = (originalTimezone: string): string => {
  // Solo aplicar corrección en Smart TVs
  if (!isSmartTV) {
    return originalTimezone;
  }
  
  // Verificar si el timezone es problemático
  const replacement = PROBLEMATIC_TIMEZONE_REPLACEMENTS[
    originalTimezone as keyof typeof PROBLEMATIC_TIMEZONE_REPLACEMENTS
  ];
  
  if (replacement) {
    console.warn(
      `[useCompany] Smart TV detected: Replacing problematic timezone "${
        originalTimezone
      }" with "${replacement}" for better compatibility`
    );
    return replacement;
  }
  
  return originalTimezone;
};

export const useCompany = () => {
  const { data } = useQuery(GET_COMPANY);

  // Aplicar corrección de timezone si es necesario
  const company = data?.company ? {
    ...data.company,
    timezone: getCorrectTimezone(data.company.timezone)
  } : undefined;

  return { company };
};
